export const PH_FEATURE_FLAGS = {
  NEWS_BANNER: "news-banner",
};

export const PH_KEYS = {
  // User
  USERNAME: "username",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  EMAIL: "email",
  EMAIL_VERIFIED: "emailVerified",
  AUTHENTICATION_METHOD: "authenticationMethod",
  JOB_FUNCTION: "jobFunction",
  SIGNUP_AT: "signupAt",
  CURRENT_PLAN: "currentPlan",
  REFERRAL_METHOD: "referralMethod",

  // Promotions
  PROMO_CODES: "promoCodes",
  SIGNUP_PROMO_CODES: "signupPromoCodes",
  PROMO_CODES_APPLIED_EVENT: "promoCodeAppliedEvent",
  PROMO_CODES_USED_TIMEZONE: "promoCodeUsedTimezone",

  // Workspace
  WORKSPACE_ID: "workspaceId",
  WORKSPACE_NAME: "workspaceName",
  WORKSPACE_CURRENT_PLAN: "workspaceCurrentPlan",
  WORKSPACE_ORIGINAL_PLAN: "workspaceOriginalPlan",
  WORKSPACE_PREVIOUS_PLAN: "workspacePreviousPlan",
  WORKSPACE_CREATED_AT: "workspaceCreatedAt",
  WORKSPACE_LAST_ACTIVE: "workspaceLastActive",
  WORKSPACE_CURRENT_PAYMENT_METHOD: "workspaceCurrentPaymentMethod",
  WORKSPACE_SIGNUP_FREE_ABSTRACTS: "workspaceSignupFreeAbstracts",

  // Transactions
  TRANSACTION_ID: "transactionId",
  FILE_NAME: "fileName",
  FILE_COUNT: "fileCount",
  FILE_SIZE: "fileSize",
  FILE_TYPE: "fileType",
  UPLOAD_METHOD: "uploadMethod",
  FILE_COUNT_TOTAL: "fileCountTotal",
  FILE_SIZE_TOTAL: "fileSizeTotal",
  FILE_TYPES: "fileTypes",
  TRANSACTION_CREATED_AT: "transactionCreatedAt",
  TOTAL_COST: "totalCost",
  TOTAL_CREDITS: "totalCredits",
  ABSTRACT_CREDITS_USED: "abstractCreditsUsed",
  CREDIT_BUNDLE_1_COUNT: "numberOfBundles1",
  CREDIT_BUNDLE_5_COUNT: "numberOfBundles5",
  CREDIT_BUNDLE_10_COUNT: "numberOfBundles10",
  CREDIT_BUNDLE_25_COUNT: "numberOfBundles25",
  BUNDLE_SIZE: "bundleSize",

  // Table Actions
  DOCUMENT_ID: "documentId",
  PAGE_NUMBER: "pageNumber",
  ROW_NUMBER: "rowNumber",
  SORT_KEY: "sortKey",
  SORT_DIRECTION: "sortDirection",
  SEARCH_TEXT: "searchText",
  REASON: "reason",

  // Refunds
  NUMBER_OF_DOCUMENTS: "numberOfDocs",
  REFUND_REQUEST_AMOUNT: "refundRequestAmount",
  REFUND_REQUESTED_AT: "refundRequestedAt",
  REFUNDED_AMOUNT: "refundedAmount",

  // Abstracts
  ABSTRACT_ID: "abstractId",
  ABSTRACT_TOTAL_COUNT: "abstractTotalCount",
  NUMBER_OF_TERMS_FOUND: "numberOfTermsFound",
  ABSTRACTION_TIME_SECONDS: "abstractionTimeSeconds",
  SINGLE_DOC_ABSTRACTS_COUNT: "singleDocAbstractsCount",
  MULTI_DOC_ABSTRACTS_COUNT: "multiDocAbstractsCount",
  SINGLE_DOC_ABSTRACTS_FILE_COUNT: "singleDocAbstractsFileCount",
  MULTI_DOC_ABSTRACTS_FILE_COUNT: "multiDocAbstractsFileCount",
  MULTI_DOC_ABSTRACTS_GROUP_COUNT: "multiDocAbstractsGroupCount",
  ABSTRACT_TYPE: "abstractType",
  NUM_OF_FILES: "numOfFiles",
  TOTAL_GROUP_COUNT: "totalGroupCount",
  PROPERTIES_ADDED: "propertiesAdded",
  RENAME_TYPE: "renameType",
  BOUNDING_BOX_CREATED: "boundingBoxCreated",
  IS_MANUAL_TAG: "isManualTag",
  ABSTRACT_SUMMARY_SECTION: "abstractSummarySection",
  CREDIT_BALANCE: "creditBalance",
  INITIATED_BY: "initiatedBy",

  // Downloads
  DOWNLOAD_TYPE: "downloadType",

  // Documents
  PAGES: "pages",

  // Other
  LOCATION: "location",

  // Document Viewer
  DOCUMENT_NAME: "documentName",
  DOCUMENT_TYPE: "documentType",
  DOCUMENT_SEQUENCE: "documentSequence",
  DOCUMENT_MOST_RECENT: "documentMostRecent",
  SOURCE_TERM: "sourceTerm",
  SOURCE_TYPE: "sourceType",
  REFERRAL_LOCATION: "referralLocation",
  BOOKMARK_TOGGLE_STATE: "bookmarkToggleState",
  HIGHLIGHT_TOGGLE_STATE: "highlightToggleState",
  TAG_BOOKMARK_CLICKED: "tagBookmarkClicked",
  PAGE_FROM: "pageFrom",
  PAGE_TO: "pageTo",
  NAVIGATION_METHOD: "navigationMethod",
  ZOOM_VALUE: "zoomValue",
  QUERY: "query",
  QUERY_RESULTS_COUNT: "queryResultsCount",
  X_VALUE: "xValue",
  Y_VALUE: "yValue",
  HEIGHT: "height",
  WIDTH: "width",
  PAGE: "page",
  TERM_NAME: "termName",
  TEXT: "text",

  // Referrals
  RECIPIENT_COUNT: "recipientCount",
  REFERRING_USER_ID: "referringUserId",
  REFFERAL_APP_LOCATION: "referralAppLocation",
  REFERRED_USER_ID: "referredUserId",
  CREDIT_AMOUNT: "creditAmount",

  // News Banner
  NEWS_BANNER_ID: "newsBannerUniqueId",
  NEWS_BANNER_HAS_BREAKDOWN: "newsBannerHasBreakdown",

  // Invites
  WORKSPACE_INVITED_EMAIL: "workspaceInvitedEmail",
};

export const PH_EVENTS = {
  USER_SIGNED_UP: "User Signed Up",
  EMAIL_VERIFIED: "Email Verified",
  USER_LOGGED_IN: "User Logged In",
  FILES_ADDED: "Files Added",
  FILES_UPLOADED: "File Uploaded",
  FILES_REMOVED: "File Upload Removed",
  FILE_SELECTION_ABANDONED: "File Selection Abandoned",
  CHECKOUT_STARTED: "Checkout Started",
  CHECKOUT_SUCCESSFUL: "Checkout Successful",
  CHECKOUT_ABANDONED: "Checkout Abandoned",
  ABSTRACTION_STARTED: "Abstraction Started",
  ABSTRACTION_SUCCESSFUL: "Abstraction Successful",
  ABSTRACTION_FAILED: "Abstraction Failed",
  LANDING_PAGE_ABSTRACT_TABLE_SORTED: "Landing Page - Abstract Table Sorted",
  LANDING_PAGE_ABSTRACT_TABLE_SEARCH: "Landing Page - Abstract Table Search",
  LANDING_PAGE_ABSTRACT_CLICKED: "Landing Page - Abstract Clicked",
  ABSTRACT_DOWNLOADED: "Abstract Downloaded",
  DOCUMENT_DOWNLOADED: "Document Downloaded",
  ABSTRACT_DELETED: "Abstract Deleted",
  ABSTRACT_VIEWED: "Abstract Viewed",
  ABSTRACT_RETRIED: "Abstraction Retried",
  ACCOUNT_SETTINGS_PASSWORD_CHANGED: "Account Settings - Password Changed",
  ACCOUNT_SETTINGS_ACCOUNT_DELETED: "Account Settings - Account Deleted",
  ACCOUNT_SETTINGS_TRANSACTION_HISTORY_RECEIPT_VIEWED:
    "Account Settings - Transaction History - Receipt Viewed",
  ACCOUNT_SETTINGS_REFUND_REQUEST_OPENED:
    "Account Settings - Refund Request Opened",
  REFUND_REQUEST_SUBMITTED: "Refund Request Submitted",
  REFUND_REQUEST_REFUNDED: "Refund Request Refunded",
  BULK_ABSTRACT_DOWNLOAD: "Bulk Abstract Download",
  PROMO_CODES_USED: "Promo codes used",
  FILE_UPLOAD_ABSTRACT_GROUP_CREATED: "File Upload - Abstract Group Created",
  FILE_UPLOAD_ABSTRACT_GROUP_DELETED: "File Upload - Abstract Group Deleted",
  FILE_UPLOAD_ABSTRACT_GROUP_RENAMED: "File Upload - Abstract Group Renamed",
  ABSTRACT_RENAMED: "Abstract Renamed",
  DOCUMENT_VIEWER_OPENED: "Document Viewer -  Opened",
  DOCUMENT_VIEWER_CLOSED: "Document Viewer - Closed",
  DOCUMENT_VIEWER_DOCUMENT_ZOOMED: "Document Viewer - Document Zoomed",
  DOCUMENT_VIEWER_DOC_PAGE_NAVIGATED: "Document Viewer - Doc Page Navigated",
  DOCUMENT_VIEWER_BOOKMARK_CLICKED: "Document Viewer - Bookmark Clicked",
  DOCUMENT_VIEWER_BOOKMARK_TOGGLED: "Document Viewer - Bookmark Toggled",
  DOCUMENT_VIEWER_HIGHLIGHT_TOGGLED: "Document Viewer - Highlight Toggled",
  CUSTOM_TERM_CREATE_MODAL_OPENED: "Custom Term - Create Modal Opened",
  CUSTOM_TERM_CREATE_SAVED: "Custom Term - Create Saved",
  DOCUMENT_VIEWER_DOC_SEARCHED: "Document Viewer - Document Searched",
  CUSTOM_TERM_UPDATE_SAVED: "Custom Term - Update Saved",
  CUSTOM_TERM_DELETE: "Custom Term - Delete",
  OCR_BOX_DRAWN: "ocrBoxDrawn",
  OCR_TEXT_RETURNED: "ocrTextReturned",
  SUMMARY_TERM_EDITED: "Summary Term Edited",
  MANUAL_TERM_CREATED: "Term Manually Created",
  INSUFFICIENT_CREDITS: "Insufficient Credits",
  AUTO_RELOAD_ENABLED: "Auto Reload Enabled",
  AUTO_RELOAD_UPDATED: "Auto Reload Updated",
  CREDITS_AUTO_RELOADED: "Credits Auto Reloaded",

  // Referrals
  REFERRAL_LINK_COPIED: "Referral Link Copied",
  REFERRAL_MODAL_OPENED: "Referral Modal Opened",
  REFERRAL_MODAL_COMPLETED: "Referral Modal Completed",
  REFERRAL_MODAL_ABANDONED: "Referral Modal Abandoned",
  REFERRAL_LINK_USED: "Referral Link Used",
  REFERRAL_CREDITS_GRANTED: "Referral Credits Granted",

  // News Banner
  NEWS_BANNER_DISMISSED: "News Banner Dismissed",
  NEWS_BANNER_CLICKED: "News Banner Clicked",

  // Workspace Management
  WORKSPACE_CREATED: "Workspace Created",
  USER_INVITED_TO_WORKSPACE: "User Invited to Workspace",
  INVITATION_ACCEPTED: "Invitation Accepted",
  INVITATION_REJECTED: "Invitation Rejected",
  INVITATION_DELETED: "Invitation Deleted",
  USER_LEFT_WORKSPACE: "User Left Workspace",
  USER_REMOVED_FROM_WORKSPACE: "User Removed from Workspace",
};

export const PH_LOCATIONS = {
  LANDING_PAGE: "Landing Page",
  ABSTRACT_SUMMARY_PAGE: "Abstract Summary Page",
  DOCUMENT_HISTORY_DRAWER: "Document History Drawer",
  HISTORY_DRAWER: "History Drawer",
  ABSTRACT_DOCUMENT_MENU: "Abstract Document Menu",
  EDIT_ANNOTATION: "Edit Annotation",
  ACCOUNT_SETTINGS: "Account Settings",
};
